import React from 'react';
import classnames from 'classnames';
import './extension-thumbnail.scss';
import { FormattedMessage } from 'react-intl';
import { Lozenge } from '@doxyme/ui';
import { AvailableFor } from '../../../marketplace-admin/constants';
function cn(name) {
    return `extension-thumbnail-${name}`;
}
export const ExtensionThumbnail = ({ extension, user, institution, onClick, isInstalled = false, isNative = false, ...rest }) => {
    const showPrice = () => {
        if (extension.tariff === 'FREE' || !extension.tariff) {
            return (<FormattedMessage id={extension.availableFor === AvailableFor.FREE
                    ? 'account.marketplace.extension.free'
                    : 'account.marketplace.extension.free_for_pro'}/>);
        }
        return <FormattedMessage id={'account.marketplace.extension.paid'}/>;
    };
    const showIsInstalledStatus = () => {
        if (isInstalled && !extension.isFake) {
            return (<div className={`${cn('status')} ${cn('status-installed')}`}>
          <span className={cn(`installed`)}>
            <FormattedMessage id={'account.marketplace.filter-installed'}/>
          </span>
        </div>);
        }
        return null;
    };
    const showIsNewStatus = () => {
        if (extension.isNew && !isNative) {
            return (<div className={`${cn('status')} ${cn('status-new')}`}>
          <Lozenge pill={true} isContrast={true} type="new" className={cn(`lozenge`)}>
            <FormattedMessage id={'account.marketplace.extension.new'}/>
          </Lozenge>
        </div>);
        }
        return null;
    };
    return (<div onClick={onClick} className={classnames(cn('wrapper'), {
            'is-disabled': !onClick,
        })} {...rest}>
      <div className={cn('head')}>
        <div className={cn('logo')}>
          <img src={extension.icon} alt={extension.title}/>
        </div>
        {showIsNewStatus()}
        {showIsInstalledStatus()}
      </div>
      <div className={cn('title')}>{extension.title}</div>
      <div className={cn('description')}>{extension.shortDescription}</div>
      {!extension.isFake && <div className={cn('price')}>{showPrice()}</div>}
      <div className={cn('details')}>
        <span className={cn('details-button')}>
          <FormattedMessage id={'account.marketplace.extension.view-details'}/>
        </span>
      </div>
    </div>);
};
